import { render, staticRenderFns } from "./UploadPersonalDocumentDialog.vue?vue&type=template&id=1d730c85&scoped=true"
import script from "./UploadPersonalDocumentDialog.vue?vue&type=script&lang=js"
export * from "./UploadPersonalDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadPersonalDocumentDialog.vue?vue&type=style&index=0&id=1d730c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d730c85",
  null
  
)

export default component.exports